import { render, staticRenderFns } from "./sent-record.vue?vue&type=template&id=11577a3c&scoped=true&"
import script from "./sent-record.vue?vue&type=script&lang=ts&"
export * from "./sent-record.vue?vue&type=script&lang=ts&"
import style0 from "./sent-record.vue?vue&type=style&index=0&id=11577a3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11577a3c",
  null
  
)

export default component.exports